// extracted by mini-css-extract-plugin
export default {"table":"MenteeModulesTable_table__8KvUs"};